import './onlineplaner.scss';

import { OPActions } from '../op-actions/op-actions';
import { CookieHandler } from '../../utilities/js/cookie-handler';
import AjaxLoad from '../../utilities/js/ajax-load';
import { checkFormInputs, trackingSend } from '../../utilities/js/dl-Tracking';
import { WidgetInstance } from 'friendly-challenge';

class OnlinePlaner {
    constructor (options) {
        this.debug = false;

        this.defaults = {
            onSubmitted: null
        };

        this.$container = document.querySelector('.site-main');
        // this.$startButton = document.querySelector('[data-op-start]');
        this.$OpOverlay = document.querySelector('[data-op-overlay]');
        this.startURL = this.$OpOverlay.getAttribute('data-op-start');
        this.$OpOverlayContent = this.$OpOverlay.querySelector('[data-op-content]');
        this.$OpOverlayClose = this.$OpOverlay.querySelector('[data-op-close]');
        this.$ajaxButtons = null;
        this.$opFrame = document.getElementById('mac_onko');
        this.cookieHandler = CookieHandler();
        this.indicators = {
            plan: document.querySelector('[data-status-type="plan"]'),
            advice: document.querySelector('[data-status-type="advice"]'),
            save: document.querySelector('[data-status-type="save"]')
        };
        this.firstStart = true;

        new OPActions({ // eslint-disable-line
            elements: [{
                selector: 'data-copy',
                confirmation: false,
                type: 'copy'
            }, {
                selector: 'data-share',
                confirmation: false,
                type: 'share'
            },
            {
                selector: 'data-delete',
                confirmation: true,
                type: 'delete'
            }]
        });

        this.settings = Object.assign({}, this.defaults, options);
    }

    init () {
        this.$OpOverlay.classList.remove('has--notrans');

        this.setEvents();

        if (this.$opFrame) {
            this.observer();
        }
    }

    start () {
        new AjaxLoad(this.startURL, { // eslint-disable-line
            requestMethod: 'post',
            onSuccess: (result) => {
                this.$OpOverlayContent.innerHTML = result;

                this.$opFrame.classList.add('is--move-out');
                this.$OpOverlay.classList.add('is--move-in');

                setTimeout(() => {
                    this.$opFrame.classList.add('is--hidden');
                    this.$opFrame.classList.remove('is--move-out');

                    this.$OpOverlay.classList.add('is--visible');
                    this.$OpOverlay.classList.remove('is--move-in');

                    // init formfields
                    const allFields = this.$OpOverlayContent.querySelectorAll('select, input:not([type="hidden"]), textarea');
                    if (allFields.length > 0) {
                        import('../../components/form-fields/form-fields.js').then(({ FormFields }) => {
                            for (let i = 0; i < allFields.length; i++) {
                                const $field = new FormFields(allFields[i]);
                                $field.initialize();
                            }
                        });

                        this.initCaptcha(this.$OpOverlayContent.querySelector('form'), this.$OpOverlayContent.querySelector('button[type="submit"]'));

                        trackingSend({
                            event: 'form_view',
                            formName: 'Kuechenplanung-Beratung',
                            context: '/online-kuechenplaner'
                        });
                    }

                    this.firstStart = false;
                }, 1750);
            }
        });
    }

    observer () {
        let status = null;

        const observer = new MutationObserver((mutations) => {
            status = this.$OpOverlayContent.querySelector('[data-status]');

            if (status) {
                this.setIndicators(JSON.parse(status.getAttribute('data-status')));
            }
        });

        observer.observe(this.$OpOverlayContent, {
            childList: true,
            subtree: true
        });
        // observer.disconnect();
    }

    setIndicators (data) {
        const statusObject = data[0]; // returns an object like this: {'advice': 'active', 'save': 'not-active'}
        const statusArray = Object.keys(statusObject); // returns ans array with the keys like this: ['advice', 'save']

        for (let i = 0; i < statusArray.length; i++) {
            const indicatorKey = statusArray[i];
            const $indicatorElement = this.indicators[indicatorKey];

            $indicatorElement.classList.remove('is--active');
            $indicatorElement.classList.remove('is--incomplete');
            $indicatorElement.classList.remove('is--complete');
            $indicatorElement.classList.remove('is--not-active');

            $indicatorElement.classList.add('is--' + statusObject[indicatorKey]);
        }
    }

    setEvents () {
        window.document.addEventListener('cop:savedPlanning', (event) => {
            this.cookieHandler.setCookie('planingid', event.detail.id, 30);
            this.start();
        }, false);

        this.$OpOverlayContent.addEventListener('click', (event) => {
            if ((event.target.getAttribute('data-op-load') !== null || event.target.getAttribute('data-pre-status') !== null || event.target.getAttribute('data-op-action') !== null) && this.firstStart === false) {
                event.preventDefault();
                let url = null;

                if (event.target.getAttribute('data-op-load') !== null) {
                    url = event.target.getAttribute('href');
                }

                if (event.target.getAttribute('data-pre-status') !== null) {
                    url = this.startURL;
                }

                if (event.target.getAttribute('data-op-action') !== null) {
                    url = this.$OpOverlayContent.querySelector('form').getAttribute('action');
                }
                const currentFormName = (this.$OpOverlayContent.querySelector('form')) ? this.$OpOverlayContent.querySelector('form').dataset.formName : '';

                new AjaxLoad(url, { // eslint-disable-line
                    requestMethod: 'post',
                    requestData: new FormData(this.$OpOverlayContent.querySelector('form')),
                    onSuccess: (result) => {
                        this.$OpOverlayContent.innerHTML = result;

                        const $newForm = this.$OpOverlayContent.querySelector('form');
                        const newFormName = ($newForm) ? $newForm.dataset.formName : '';

                        if ((currentFormName !== newFormName) && event.target.getAttribute('data-op-load') === null) {
                            trackingSend({
                                event: 'form_success',
                                formName: currentFormName,
                                context: '/online-kuechenplaner'
                            });
                        }

                        // init formfields
                        const allFields = this.$OpOverlayContent.querySelectorAll('select, input:not([type="hidden"]), textarea');
                        if (allFields.length > 0) {
                            import('../../components/form-fields/form-fields.js').then(({ FormFields }) => {
                                for (let i = 0; i < allFields.length; i++) {
                                    const $field = new FormFields(allFields[i]);
                                    $field.initialize();
                                }
                            });

                            this.initCaptcha(this.$OpOverlayContent.querySelector('form'), this.$OpOverlayContent.querySelector('button[type="submit"]'));

                            if (newFormName !== '') {
                                if (newFormName !== currentFormName) {
                                    trackingSend({
                                        event: 'form_view',
                                        formName: newFormName,
                                        context: '/online-kuechenplaner'
                                    });
                                }
                            }
                        } else {
                            const $success = this.$OpOverlayContent.querySelector('[data-planing-success]');

                            if ($success) {
                                trackingSend({
                                    event: 'form_success',
                                    formName: 'Kuechenplanung-Success',
                                    context: '/online-kuechenplaner'
                                });
                            }
                        }
                    }
                });
            }

            if (event.target.getAttribute('data-pre-status') !== null) {
                this.setIndicators(JSON.parse(event.target.getAttribute('data-pre-status')));
            }
        });

        this.$OpOverlayClose.addEventListener('click', (e) => {
            e.preventDefault();

            this.$opFrame.classList.add('is--move-in');
            this.$OpOverlay.classList.add('is--move-out');
            const $currentForm = this.$OpOverlay.querySelector('form');

            if ($currentForm) {
                const currentFormName = $currentForm.dataset.formName;
                if (currentFormName) {
                    if (currentFormName !== 'Kuechenplanung-Beratung') {
                        trackingSend({
                            event: 'form_abandonment',
                            formName: currentFormName,
                            context: '/online-kuechenplaner',
                            status: checkFormInputs($currentForm)
                        });
                    } else {
                        trackingSend({
                            event: 'form_abandonment',
                            formName: currentFormName,
                            context: '/online-kuechenplaner'
                        });
                    }
                }
            }

            setTimeout(() => {
                this.$OpOverlay.classList.remove('is--visible');
                this.$OpOverlay.classList.remove('is--move-out');

                this.$opFrame.classList.remove('is--hidden');
                this.$opFrame.classList.remove('is--move-in');
            }, 1750);
        });
    }

    initCaptcha ($form, $button) {
        const $friendlyCaptcha = $form.querySelector('.frc-captcha');

        if ($friendlyCaptcha) {
            $button.classList.add(this.settings.buttonDisabledClass);

            const widget = new WidgetInstance($friendlyCaptcha, {  // eslint-disable-line
                skipStyleInjection: true,
                doneCallback: () => {
                    this.captchaIsReady = true;

                    this.checkValidationAndCaptcha($button);
                }
            });

            $form.addEventListener('change', () => {
                this.checkValidationAndCaptcha($button);
            });

            $form.dispatchEvent(new Event('change', {
                bubbles: true,
                cancelable: true
            }));
        }
    }

    checkValidationAndCaptcha ($button) {
        if (this.captchaIsReady) {
            $button.classList.remove(this.settings.buttonDisabledClass);
        } else {
            $button.classList.add(this.settings.buttonDisabledClass);
        }
    }
}

export { OnlinePlaner };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;
    if ($context) {
        const $op = $context.querySelector('[data-op-start]');

        if ($op) {
            const onlinePlaner = new OnlinePlaner();
            onlinePlaner.init();
        }
    }
});
